import {
  REGISTRATION_WAIT_MS,
  usePushRegistrationLifecycle,
} from "../../../push/PushRegistrationLifecycleProvider";

export { REGISTRATION_WAIT_MS };

export default function usePushRegistrationController() {
  return usePushRegistrationLifecycle();
}
